import { Stack, SxProps, Typography, useTheme } from "@mui/material";
import { ClientRequest } from "../../models/user.models";
import { DateTimeService } from "../../services/date-time.service";

interface RequestListProps {
  requests: ClientRequest[];
  sx?: SxProps;
}

const RequestList = ({ requests, sx }: RequestListProps) => {
  const theme = useTheme();
  return (
    <Stack sx={{ ...sx, boxShadow: "0px 2px 10px 0px #4C4E6438" }}>
      {requests.map((request) => (
        <Stack
          sx={{
            padding: "20px",
            borderBottom: "1px solid lightgray",
            marginInline: "10px",
          }}
        >
          <Stack
            sx={{ marginBottom: "15px" }}
            flexDirection={"row"}
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <Typography
              sx={{
                fontWeight: "500",
                fontSize: "20px",
                ...theme.customStyles.ellipsisOneLine,
              }}
            >
              {request.subject}
            </Typography>
            <Typography>
              {DateTimeService.convertDateToDDMMYYYY(
                new Date(request.createdAt)
              )}
            </Typography>
          </Stack>
          <Typography>{request.message}</Typography>
        </Stack>
      ))}
    </Stack>
  );
};

export default RequestList;
